export default {
	requiredMessage: '请选择一个值。'
};
